(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.currentHeaderState = 'initial';
      this.scrollFrameRequested = false;
      this.pendingScrollTop = 0;
      this.lastHeaderHeight = null;

      this.setHeaderHeight();

      this._dsdMediaQuery = window.matchMedia('(max-width: 990px)');
      this._dsdSetHeaderHeight = this.setHeaderHeight.bind(this);
      this._dsdMediaQuery.addEventListener('change', this._dsdSetHeaderHeight);

      if (this.headerIsAlwaysSticky && !this.header.classList.contains('shopify-section-header-sticky')) {
        this.header.classList.add('shopify-section-header-sticky');
        this.currentHeaderState = 'sticky';
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });

      this.createObserver();
    }

    setHeaderHeight() {
      const nextHeight = this.header ? this.header.offsetHeight : 0;
      if (nextHeight && nextHeight !== this.lastHeaderHeight) {
        this.lastHeaderHeight = nextHeight;
        document.documentElement.style.setProperty('--header-height', `${nextHeight}px`);
      }
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      if (this._dsdMediaQuery && this._dsdSetHeaderHeight) {
        this._dsdMediaQuery.removeEventListener('change', this._dsdSetHeaderHeight);
      }
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      this.pendingScrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.scrollFrameRequested) return;
      this.scrollFrameRequested = true;
      requestAnimationFrame(() => {
        this.scrollFrameRequested = false;
        this.applyScrollState(this.pendingScrollTop);
      });
    }

    applyScrollState(scrollTop) {
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.setScrolledPast(true);
        if (!this.preventHide) this.hide();
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.setScrolledPast(true);
        if (!this.preventReveal) {
          this.reveal();
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => { this.preventReveal = false; }, 66);
          this.hide();
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.setScrolledPast(false);
        this.reset();
      }

      this.currentScrollTop = scrollTop;
    }

    setScrolledPast(active) {
      if (!this.header) return;
      const hasClass = this.header.classList.contains('scrolled-past-header');
      if (active && !hasClass) this.header.classList.add('scrolled-past-header');
      if (!active && hasClass) this.header.classList.remove('scrolled-past-header');
    }

    applyHeaderState(nextState) {
      if (this.headerIsAlwaysSticky || !this.header || this.currentHeaderState === nextState) return;
      this.currentHeaderState = nextState;
      if (nextState === 'hidden') {
        this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
        this.header.classList.remove('animate');
      } else if (nextState === 'revealed') {
        this.header.classList.add('shopify-section-header-sticky', 'animate');
        this.header.classList.remove('shopify-section-header-hidden');
      } else {
        this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      }
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.applyHeaderState('hidden');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.applyHeaderState('revealed');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.applyHeaderState('reset');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
